import { VendedorSelectService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/services/api/vendedor-service/vendedor-service.service';
import { NewApiUserService } from './../../../api/new-api-user/new-api-user.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, combineLatest, finalize, map, Observable, shareReplay, Subscription, switchMap } from 'rxjs';
import { AmountValueService } from '../../../api/amount-value/amount-value.service';
import { SellHistory } from '../models/home.models';
import { Product } from '@brunsker/libs/portal-do-vendedor/ui/product-card';
import {
  ClienteApiService,
  ClienteProxiInatResponse,
  ClientData,
  MapperService,
  SelectClientService,
  CUSTOMER_PORTFOLIO_TYPE,
} from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';
import { IPieGraphTotalizer } from '@brunsker/libs/portal-do-vendedor/ui/generate-graph/lib/models/data-models';
import { NewApiRelatoriosService } from '../../../api/new-api-relatorios/new-api-relatorios.service';
import { BrazilianCurrencyPipe } from '@brunsker/libs/core/utils/brazilian-currency/src/lib/pipes/brazilian-currency/brazilian-currency.pipe';
import { NewApiProductService } from '../../../api/new-api-product/new-api-product.service';
import {
  SALES_SUMMARY_POSITION,
} from '../../../../models/orcamento.models';

@Injectable({
  providedIn: 'root',
})
export class WelcomeDomainService {
  hasClient = this.selectClientService.hasClient$$;
  defaultFilial = 1;
  products$!: Observable<Product[]>;
  user!: string;
  currentDate = new Date();
  month = this.currentDate.getMonth();
  year = this.currentDate.getFullYear();

  readonly backgroundColorByPosition: { [key: string]: string } = {
    [SALES_SUMMARY_POSITION.budget]: '#664DC9',
    [SALES_SUMMARY_POSITION.order]: '#4DC9C9',
    [SALES_SUMMARY_POSITION.invoiced]: 'var(--pv-blue-02)',
    [SALES_SUMMARY_POSITION.returned]: 'var(--pv-orange)',
    [SALES_SUMMARY_POSITION.cancelled]: 'var(--pv-red-01)',
    [SALES_SUMMARY_POSITION.billingForecast]: 'var(--pv-green-02)',
  };

  readonly NAME_STRING: {
    [key: string]: string;
  } = {
    [SALES_SUMMARY_POSITION.budget]: 'ORÇAMENTO',
    [SALES_SUMMARY_POSITION.order]: 'PEDIDO',
    [SALES_SUMMARY_POSITION.invoiced]: 'FATURADO',
    [SALES_SUMMARY_POSITION.returned]: 'DEVOLUÇÃO',
    [SALES_SUMMARY_POSITION.cancelled]: 'CANCELADO',
    [SALES_SUMMARY_POSITION.billingForecast]: 'PREVISÃO DE FATURAMENTO',
  };

  private readonly indicatorMonth = new BehaviorSubject(new Date(this.year, this.month, 1));
  sellHistory!: Observable<SellHistory[]>;
  client!: ClientData | null;

  readonly tableTitleDefault = 'Clientes Próximos de ficarem Inativos';
  readonly tableSubtitleDefault = 'ÚLTIMOS 35 DIAS';

  private readonly customers =
    new BehaviorSubject<ClienteProxiInatResponse[] | null>(null);
  readonly data$ = this.customers.asObservable();
  readonly customersLoading$ = new BehaviorSubject(false);
  readonly customersError$ = new BehaviorSubject(false);
  private readonly customersLimit = 10;
  private customerCategory: string = CUSTOMER_PORTFOLIO_TYPE.NEXT_INACTIVE;
  private customersRequest?: Subscription;
  tableTitle = this.tableTitleDefault;
  tableSubtitle = this.tableSubtitleDefault;

  constructor(
    private readonly route: Router,
    readonly mapperService: MapperService,
    private readonly selectClientService: SelectClientService,
    private readonly newApiRelatoriosService: NewApiRelatoriosService,
    private readonly brazilianPipe: BrazilianCurrencyPipe,
    private readonly newApiProductService: NewApiProductService,
    private readonly amountValueService: AmountValueService,
    private readonly newApiUserService: NewApiUserService,
    private readonly vendedorSelectService: VendedorSelectService,
    private readonly clienteApiService: ClienteApiService,
  ) {}

  start(): void {
    this.products$ = this.createProdutoData();
    const userStringify = sessionStorage.getItem('user');
    const user = userStringify && JSON.parse(userStringify);

    this.newApiUserService.currentUser$$.subscribe((v) => {
      this.user = v?.username ?? '';
    });

    const cliente = this.selectClientService.getCliente();
    if (cliente?.tipoVenda == 8) {
      this.selectClientService.resetClient();
    }

    this.sellHistory = combineLatest([
      this.indicatorMonth,
      this.selectClientService.hasClient$$,
    ]).pipe(
      switchMap(([month]) => {
        const client = this.selectClientService.getCliente();
        return this.newApiRelatoriosService.getTotalizadoresVendas({
          matricula: user.idFuncionario,
          clientId: client?.id,
          PCODUSUR: client?.vendedor ?? user.idVendedor,
          DT_INIT: new Date(month.getFullYear(), month.getMonth(), 1)
            .toLocaleDateString('pt-BR'),
          DT_FIM: new Date(month.getFullYear(), month.getMonth() + 1, 0)
            .toLocaleDateString('pt-BR'),
        });
      }),
      map((response) => response.totalVendas.map((element): SellHistory => ({
        name: this.NAME_STRING[element.posicao],
        posicao: element.posicao,
        status: element.status,
        total: this.brazilianPipe.transform(element.valorTotal) ?? '0',
        quantity: element.valores ?? undefined,
        backgroundColor: this.backgroundColorByPosition[element.posicao],
        routerLink: '/historico-de-vendas',
      }))),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

    this.selectClientService.hasClient$$.subscribe((hasClient: any) => {
      if (hasClient) {
        this.products$ = this.createProdutoData();
      }
    });
  }

  setIndicatorMonth(month: Date): void {
    this.indicatorMonth.next(new Date(month.getFullYear(), month.getMonth(), 1));
  }

  createProdutoData() {
    this.client = this.selectClientService.getCliente();
    const user = JSON.parse(sessionStorage.getItem('user') ?? '');
    const filial = this.client?.filial ?? this.defaultFilial;
    return this.newApiProductService
      .getInformationProduct({
        codigoUsuario: this.client?.vendedor ?? user.idVendedor,
        codigoPlanoPagamento: this.client?.planoDePagamento ?? 0,
        codigoCobranca: this.client?.formaDePagamento ?? '',
        INTERVALO: 30,
        LINHAINICIAL: 0,
        FILIAL: filial,
        ORDER_AZ: 1,
        HOMEPAGE: true,
        codigoCliente: this.client?.id,
        pLANCAMENTO: 0,
        pNOVOEST: 0,
        pPRECOPROM: 0,
        matricula: this.vendedorSelectService.vendedorActiv(),
      })
      .pipe(
        map((products) => {
          return products.data.map((product) => {
            const taxa = +product.preco * this.amountValueService.AMOUNT_VALUE;
            const nomE_PRODUTO = product.nomE_PRODUTO.split('-');

            if (!nomE_PRODUTO.includes(product.sku.toString())) {
              product.nomE_PRODUTO = product.sku + ' - ' + product.nomE_PRODUTO;
            }
            return {
              id: +product.sku,
              name: product.nomE_PRODUTO,
              image: product.dirfotoprod,
              stock: +product.qT_DISPONIVEL,
              olderPrice: +product.preco,
              newPrice: +product.preco + taxa,
              filial: product.iD_FILIAL,
              multiplo: product.multiplo,
              pLANCAMENTO: product.pLANCAMENTO,
              pNOVOEST: product.pNOVOEST,
              pPRECOPROM: product.pPRECOPROM,
              descontoMaximo: product.descontoMaximoResponse,
            } as Product;
          });
        }),
      );
  }

  startAfterView(): void {
    this.user = this.newApiUserService.currentUser$$.value?.username!;
  }

  getProduct(id: number): void {
    this.route.navigate(['/products/', id]);
  }

  totalizerDataChange(totalizer: IPieGraphTotalizer | null): void {
    const label = totalizer?.label?.toLowerCase() ?? '';
    this.tableTitle = this.tableTitleDefault;
    this.tableSubtitle = this.tableSubtitleDefault;
    switch (label) {
      case CUSTOMER_PORTFOLIO_TYPE.INACTIVE:
        this.tableTitle = 'Clientes Inativos';
        this.tableSubtitle = '';
        break;
      case CUSTOMER_PORTFOLIO_TYPE.ACTIVE:
        this.tableTitle = 'Clientes Ativos';
        this.tableSubtitle = '';
        break;
    }

    this.cancelCustomersRequest();
    this.customerCategory = label;
    this.customers.next(null);
    this.loadCustomers();
  }

  cancelCustomersRequest(): void {
    this.customersRequest?.unsubscribe();
  }

  loadCustomers(): void {
    if (this.customersLoading$.value) return;

    this.customersLoading$.next(true);
    this.customersError$.next(false);
    const id = this.getUserId();
    const index = 1;
    const length = this.customersLimit;
    const request$ = this.customerCategory === CUSTOMER_PORTFOLIO_TYPE.ACTIVE
      ? this.clienteApiService.getActive(id, index, length)
      : this.customerCategory === CUSTOMER_PORTFOLIO_TYPE.INACTIVE
        ? this.clienteApiService.getInactive(id, index, length)
        : this.clienteApiService.getNextInactive(id, index, length);

    this.customersRequest = request$
      .pipe(finalize(() => this.customersLoading$.next(false)))
      .subscribe({
        next: (response) => {
          const page = Array.isArray(response) ? response : response?.data ?? [];
          this.customers.next(page.slice(0, this.customersLimit).map((item) => ({
            ...item,
            data: item.data
              ? new Date(item.data).toLocaleDateString('pt-BR', {
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                })
              : '-',
          })));
        },
        error: () => {
          this.customersError$.next(true);
          if (this.customers.value === null) this.customers.next([]);
        },
      });
  }

  private getUserId(): number {
    const user = JSON.parse(sessionStorage.getItem('user') || '{}');
    return user?.idVendedor;
  }
}
